import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React from 'react';
import { OptionListFooterContainer } from './style';
import { OPTION_LIST_FOOTER_CLASS_PREFIX } from './constants';
import { useOptionListFooterClassName } from './hooks/useOptionListFooterClassName';
import { useComponentTheme } from '../../utils/hooks';
import { Button } from '../Button';
import { useOptionListFooter } from './hooks/useOptionListFooter';
export var OptionListFooter = function OptionListFooter(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(OPTION_LIST_FOOTER_CLASS_PREFIX);
  var classOverride = useOptionListFooterClassName(OPTION_LIST_FOOTER_CLASS_PREFIX, className);

  var _useOptionListFooter = useOptionListFooter(props),
      rootProps = _useOptionListFooter.rootProps,
      footerContent = _useOptionListFooter.footerContent,
      footerCancelButtonProps = _useOptionListFooter.footerCancelButtonProps,
      footerConfirmButtonProps = _useOptionListFooter.footerConfirmButtonProps;

  return React.createElement(OptionListFooterContainer, Object.assign({}, rootProps, {
    theme: theme,
    className: classOverride.Root
  }), footerContent || React.createElement(React.Fragment, null, React.createElement(Button, Object.assign({
    tertiary: true,
    paddingX: 1
  }, footerCancelButtonProps, {
    theme: theme,
    className: classOverride.CancelButton
  }), "Cancel"), React.createElement(Button, Object.assign({}, footerConfirmButtonProps, {
    theme: theme,
    className: classOverride.ConfirmButton
  }), "Confirm")));
};